import type {
	AccountFacilityPayload,
	AccountFacilityStatus,
} from '@Application/Facilities/Facilities/Actions/accountFacilitiesFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AccountFacilityView {
	readonly id: number;
	readonly name: string;
	readonly status: AccountFacilityStatus;
	readonly address: string | null;
	readonly phoneNumber: string | null;
	readonly organizationId: number;

	constructor(payload: AccountFacilityPayload) {
		this.id = payload.id;
		this.name = payload.name;
		this.status = payload.status;
		this.address = payload.address;
		this.phoneNumber = payload.phoneNumber;
		// The API answers `organization: { id }`; reading `payload.organizationId` would silently be
		// `undefined` and produce orphan facilities once composed with organizations.
		this.organizationId = payload.organization.id;

		Object.freeze(this);
	}
}

export default AccountFacilityView;
